import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { confirm } from 'devextreme/ui/dialog';
import * as _ from 'lodash';
import moment from 'moment';
import { AppInformationService, AuthService, CdrUnitOfWork, UtilityService } from 'src/app/core/core.module';
import { Dumpster } from 'src/app/core/model/dumpster';
import { Job } from 'src/app/core/model/job';
import { JobType } from 'src/app/core/model/job-type';
import { Rental } from 'src/app/core/model/rental';
import { JobDialogComponent } from 'src/app/rentals/job-dialog/job-dialog.component';
import { DialogService } from 'src/app/shared/dialog.service';
import { InputDialogComponent } from 'src/app/shared/input-dialog/input-dialog.component';
import { JobNoteDialogComponent } from '../job-note-dialog/job-note-dialog.component';
import { alert } from 'devextreme/ui/dialog';
import { RecurringJobDialogComponent } from '../recurring-job-dialog/recurring-job-dialog.component';
import { DevExtremeModule } from 'devextreme-angular';

@Component({
    selector: 'app-schedule-overview',
    templateUrl: './schedule-overview.component.html',
    styleUrls: ['./schedule-overview.component.scss'],
    imports: [CommonModule, DevExtremeModule, RouterLink]
})
export class ScheduleOverviewComponent implements OnInit {
    today: Date;
    scheduleDate: Date;
    drivers: any;
    interval: any;
    hideAllButLastCompleted: boolean = false;

    jobs: any;
    assignedJobs: any;
    unAssignedJobs: any;
    jobTypes: JobType[];
    dumpsters: Dumpster[];
    storageDumpSitesList: any;
    driverColumns: any[];

    jobContextMenuItems = [];
    unassignedJobContextMenuItems = [];

    contextMenuJobId: number;
    isScheduleAdmin = false;

    constructor(
        private uow: CdrUnitOfWork,
        private auth: AuthService,
        private appInfo: AppInformationService,
        private dialogService: DialogService,
        private utility: UtilityService,
        private router: Router
    ) {}

    async ngOnInit() {
        this.isScheduleAdmin = this.auth.hasRole('Schedule:Admin');

        if (!this.isScheduleAdmin) {
            this.jobContextMenuItems = [{ index: 1, text: 'Open' }];
            this.unassignedJobContextMenuItems = [{ index: 1, text: 'Open' }];
        } else {
            this.jobContextMenuItems = [
                { index: 1, text: 'Open' },
                { index: 2, text: 'Add Note' },
                { index: 3, text: 'UnAssign' },
                { index: 4, text: 'Delete' },
                { index: 8, text: 'Copy' },
                { index: 10, text: 'Pause Job' }
            ];
            this.unassignedJobContextMenuItems = [
                { index: 1, text: 'Open' },
                { index: 2, text: 'Add Note' },
                { index: 4, text: 'Delete' }
            ];
        }
        if (this.auth.hasRole('Schedule:CanComplete')) {
            this.jobContextMenuItems.push({ index: 5, text: 'Complete' });
            this.unassignedJobContextMenuItems.push({ index: 5, text: 'Complete' });
        }

        if (this.auth.hasRole('Schedule:CanUnComplete')) {
            this.jobContextMenuItems.push({ index: 6, text: 'UnComplete' });
            this.unassignedJobContextMenuItems.push({ index: 6, text: 'UnComplete' });
        }

        if (this.auth.hasRole('Admin')) {
            this.jobContextMenuItems.push({ index: 7, text: 'Toggle TrailerUsed' });
            this.jobContextMenuItems.push({ index: 11, text: 'Add Recurrence' });
            this.unassignedJobContextMenuItems.push({ index: 11, text: 'Add Recurrence' });
        }

        this.jobContextMenuItems.push({ index: 9, text: 'Open Rental' });
        this.unassignedJobContextMenuItems.push({ index: 9, text: 'Open Rental' });

        this.today = moment(new Date()).startOf('day').toDate();
        this.scheduleDate = this.today;
        this.jobTypes = this.uow.lookups.jobTypes as JobType[];
        this.dumpsters = this.uow.lookups.dumpsters as Dumpster[];
        this.drivers = await this.uow.getDrivers();
        const inventories = await this.uow.getAllInventories();

        this.driverColumns = [];
        this.drivers.forEach(driver => {
            this.driverColumns.push({
                id: driver.userId,
                displayOrder: driver.displayOrder,
                name: driver.firstName + ' ' + driver.lastName,
                assignedJobs: [],
                storageDumpSitesList: []
            });
        });
        await this.refresh();
        this.interval = setInterval(async () => {
            await this.getData();
        }, 300000);
    }

    async ngOnDestroy() {
        clearInterval(this.interval);
    }

    async refresh() {
        this.appInfo.pleaseWaitShow();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async getData() {
        const jobs = await this.uow.jobs.getJobsByDate(this.scheduleDate, this.hideAllButLastCompleted, {
            orderBy: 'driverId, displayOrder',
            expand: 'dumpSite, jobTimes, placedDumpsterLocations'
        });

        const otherDumpsterJobs = await this.uow.jobs.getNonCDRDumpsterJobs(this.scheduleDate);
        otherDumpsterJobs.forEach(otherDumpsterJob => {
            const found = _.find(jobs, { id: otherDumpsterJob });
            if (found) found._nonCDRDumpster = true;
        });

        jobs.forEach(x => {
            x._isStarted = x.calcIsStarted();
            x._isPaused = x.calcIsPaused();
            x._totalTime = x.calcTotalTime();
        });
        this.jobs = jobs;
        const unAssignedJobs = this.jobs.filter(job => {
            return !job.driverId && !job.completed;
        });
        this.unAssignedJobs = {
            id: -1,
            name: 'unAssignedJobs',
            assignedJobs: unAssignedJobs
        };

        const storageDumpSites = await this.uow.getActiveStorageDumpSites();

        const inventoryInfo = await this.uow.getInventoryInfo();
        storageDumpSites.forEach((site: any) => {
            let siteArray = [];
            inventoryInfo.currentInventoryInfos.forEach(info => {
                info.locations.forEach(location => {
                    if (location.storageId === site.id) {
                        siteArray.push(`${info.name} --- ${location.quantity}`);
                    }
                });
            });
            site.locationsHTML = siteArray.join('<br/>');
        });

        this.storageDumpSitesList = {
            id: -1,
            name: 'storageDumpSites',
            storageDumpSites: storageDumpSites
        };

        this.driverColumns.forEach((driver: any) => {
            driver.assignedJobs = this.jobs.filter(x => x.driverId === driver.id);
        });
    }

    async toggleHideCompleted() {
        this.hideAllButLastCompleted = !this.hideAllButLastCompleted;
        await this.getData();
    }

    changeDate(offset: number) {
        this.scheduleDate = moment(this.scheduleDate).add(offset, 'days').toDate();
    }

    async onDateChanged() {
        await this.getData();
    }

    onListDragStart(e) {
        if (!this.isScheduleAdmin) return;
        e.itemData = e.fromData[e.fromIndex];
    }

    async onListReorder(e) {
        if (!this.isScheduleAdmin) return;
        this.driverColumns.splice(e.fromIndex, 1)[0];
        this.driverColumns.splice(e.toIndex, 0, e.itemData);
        this.updateDisplayOrder(this.driverColumns);
        this.sortArray(this.driverColumns);
        await this.uow.commit();

        this.driverColumns.forEach(column => {
            const driver = _.find(this.drivers, { userId: column.id });
            driver.displayOrder = column.displayOrder;
        });
        await this.uow.commit();
    }
    sortArray(rows: any[]) {
        rows.sort((a, b) => (a.displayOrder || 9999) - (b.displayOrder || 9999));
    }

    updateDisplayOrder(rows: any[]) {
        rows.forEach((row, index) => {
            if (row.displayOrder !== index + 1) row.displayOrder = index + 1;
        });
    }
    onstorageDumpSitesDragStart(e) {
        if (!this.isScheduleAdmin) return;
        e.itemData = e.fromData.storageDumpSites[e.fromIndex];
    }

    async onstorageDumpSitesDrop(e) {
        if (!this.isScheduleAdmin) return;
        if (e.fromData.name !== 'storageDumpSites') return;
        (e.fromData.storageDumpSites as []).splice(e.fromIndex, 1);
        (e.toData.storageDumpSites as any[]).splice(e.toIndex, 0, e.itemData);
        this.updateDisplayOrder(this.storageDumpSitesList.storageDumpSites);
        this.sortArray(this.storageDumpSitesList.storageDumpSites);
        await this.uow.commit();
    }

    onTaskDragStart(e) {
        if (!this.isScheduleAdmin) return;
        e.itemData = e.fromData.assignedJobs[e.fromIndex];
    }

    onTaskDrop(e) {
        if (!this.isScheduleAdmin) return;
        if (e.fromData.name === 'storageDumpSites') {
            if (e.toData.name === 'unAssignedJobs') return;
            const job = this.uow.jobs.createEntity({
                created: moment(new Date()).toDate(),
                createdBy: this.auth.userValue.userName,
                driverId: e.toData.id,
                jobTypeId: JobType.Types.Destination,
                startDate: this.scheduleDate,
                siteName: e.itemData.name,
                address1: e.itemData.address1,
                address2: e.itemData.address2,
                city: e.itemData.city,
                state: e.itemData.state,
                zip: e.itemData.zip,
                storageDumpSiteId: e.itemData.id
            });
            e.toData.assignedJobs.splice(e.toIndex, 0, job);
        } else {
            (e.fromData.assignedJobs as []).splice(e.fromIndex, 1);

            // if moving destination to unassigned jobs, delete it instead of adding it to the list
            if (e.toData.id === -1 && e.itemData.jobTypeId === JobType.Types.Destination) e.itemData.deleted = new Date();
            else e.toData.assignedJobs.splice(e.toIndex, 0, e.itemData);

            if (e.toData.id === -1) {
                e.itemData.driverId = null;
            } else e.itemData.driverId = e.toData.id;
        }
        this.updateDisplayOrder(e.toData.assignedJobs);
        this.sortArray(e.toData.assignedJobs);
        this.uow.commit();
    }

    onContextMenu(id) {
        this.contextMenuJobId = id;
    }

    async onContextMenuItemClick(e: any) {
        const job = await this.uow.jobs.byId(this.contextMenuJobId, 'rental, fuelRatePercentage');
        switch (e.itemData.index) {
            case 1:
                await this.openJob(job);
                break;
            case 2:
                await this.addNote(job);
                break;
            case 3:
                if (job.jobTypeId === JobType.Types.Destination) job.deleted = new Date();
                else job.driverId = null;
                await this.uow.commit();
                break;
            case 4:
                await this.deleteJob(job);
                break;
            case 5:
                await this.completeJob(job);
                break;
            case 6:
                await this.unCompleteJob(job);
                break;
            case 7:
                await this.toggleTrailerUsed(job);
                break;
            case 8:
                await this.copyJob(job);
                break;
            case 9:
                await this.openRental(job);
                break;
            case 10:
                await this.pauseJob(job);
                break;
            case 11:
                await this.createRecurringJob(job);
                break;
        }
        await this.getData();
    }

    async copyJob(job: Job) {
        // if (job.completed) {
        //     this.appInfo.notifyToast('You can only copy non-completed jobs', 'error');
        //     return;
        // }
        if (job.jobTypeId !== JobType.Types.Destination && job.jobTypeId !== JobType.Types.Note) {
            this.appInfo.notifyToast('You can only copy Destination and Note jobs', 'error');
            return;
        }
        this.appInfo.pleaseWaitShow();
        const newJob = this.uow.jobs.createEntity({
            jobTypeId: job.jobTypeId,
            rentalId: job.rentalId,
            driverId: job.driverId,
            notes: job.notes,
            created: new Date(),
            createdBy: this.auth.userValue.userName,
            startDate: this.scheduleDate,
            address1: job.address1,
            address2: job.address2,
            city: job.city,
            state: job.state,
            zip: job.zip,
            dumpsterId: job.dumpsterId,
            driverNotes: job.driverNotes,
            displayOrder: 99,
            siteName: job.siteName,
            latitude: job.latitude,
            longitude: job.longitude,
            storageDumpSiteId: job.storageDumpSiteId,
            actionId: job.actionId,
            fuelRatePercentage: job.fuelRatePercentage
        });
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async toggleTrailerUsed(job: Job) {
        this.appInfo.pleaseWaitShow();
        job.trailerUsed = !job.trailerUsed;
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async addJobNote() {
        let job = this.uow.jobs.createEntity({
            jobTypeId: JobType.Types.Note,
            created: new Date(),
            createdBy: this.auth.userValue.userName,
            startDate: this.scheduleDate
        });

        const dialogRef = this.dialogService.open(JobNoteDialogComponent);
        dialogRef.instance.job = job;
        dialogRef.instance.drivers = this.drivers;
        const result = await dialogRef.instance.show();
        this.dialogService.close(dialogRef);

        if (result.success) {
            this.appInfo.pleaseWaitShow();
            await this.uow.commit();
            await this.getData();
            this.appInfo.pleaseWaitHide();
        } else this.uow.rollback();
        this.dialogService.close(dialogRef);
    }

    async addNote(job: Job) {
        const dialogRef = this.dialogService.open(InputDialogComponent);
        dialogRef.instance.dialogHeader = 'Job Note';
        dialogRef.instance.dialogPrompt = 'Add Job Note';
        dialogRef.instance.dialogValue = job.notes;
        dialogRef.instance.mode = 'textarea';
        const result = await dialogRef.instance.show();
        this.dialogService.close(dialogRef);

        if (result.success && result.value) {
            job.notes = result.value;
            this.appInfo.pleaseWaitShow();
            await this.uow.commit();
            await this.getData();
            this.appInfo.pleaseWaitHide();
        }
        this.dialogService.close(dialogRef);
    }

    async openJob(job: Job, canComplete?: boolean) {
        const dialogRef = this.dialogService.open(JobDialogComponent);
        dialogRef.instance.rentals = [job.rental];
        dialogRef.instance.completeJobMode = canComplete;
        dialogRef.instance.job = job;
        const results = await dialogRef.instance.show();
        if (results.success) {
            this.appInfo.pleaseWaitShow();
            await this.uow.commit();
            await this.getData();
            this.appInfo.pleaseWaitHide();
        } else this.uow.rollback();
        this.dialogService.close(dialogRef);
    }

    async deleteJob(job: Job) {
        if (job.calcIsStarted()) {
            await alert('This job is currently in process. Please pause the job before deleting it.', this.appInfo.appTitle);
            return;
        }

        const result = await confirm('Are you sure you want to delete the selected job?', this.appInfo.appTitle);
        if (!result) return;

        job.deleted = new Date();

        const jobTimes = await this.uow.getJobTimesByJobId(job.id);
        jobTimes.forEach(x => {
            x.deleted = new Date();
            x.deletedBy = this.auth.userValue.userName;
        });

        this.appInfo.pleaseWaitShow();
        await this.uow.commit();
        if (!!job.rentalId) await this.utility.updateRentalStatuses([job.rentalId]);
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async completeJob(job: Job) {
        const result = await confirm('Are you sure you want to complete the selected job?', this.appInfo.appTitle);
        if (!result) return;
        this.openJob(job, true);

        // job.completed = new Date();

        // this.appInfo.pleaseWaitShow();
        // await this.uow.commit();
        // await this.getData();
        // this.appInfo.pleaseWaitHide();
    }

    async unCompleteJob(job: Job) {
        if (job.jobTypeId == JobType.Types.PickUp) {
            await alert('Pickups cannot be uncompleted.', this.appInfo.appTitle);
            return;
        }

        if (job.jobTypeId == JobType.Types.Delivery && job.placedDumpsterLocations.some(x => x.removedJobId)) {
            await alert('Deliveries cannot be uncompleted after the dumpster has been removed.', this.appInfo.appTitle);
            return;
        }

        const result = await confirm('Are you sure you want to un-complete the selected job?', this.appInfo.appTitle);
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        await this.utility.uncompleteJob(job.id);
        job.completed = null;
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async deleteRental(rental: Rental) {
        if (!(await confirm('Are you sure you want to delete the selected rental?', this.appInfo.appTitle))) return;

        rental.deleted = moment(new Date()).toDate();

        this.appInfo.pleaseWaitShow();
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    getTasks() {}

    openMaps(entity: any) {
        const address = (
            entity.latitude && entity.longitude ? [entity.latitude, entity.longitude] : entity.fullAddress.trim().split(' ')
        ).join('+');
        let url = '';
        try {
            //  url = `https://maps.apple.com/?q=${address}`;
            url = `https://www.google.com/maps?q=${address}`;
            window.open(url, '_blank');
        } catch (error) {
            alert(error, this.appInfo.appTitle);
        }
    }

    async openRental(job: Job) {
        if (!!job.rentalId) {
            this.router.navigate([`/rentals/${job.rentalId}`]);
        } else {
            await alert('Selected job does not have a rental.', this.appInfo.appTitle);
        }
    }

    async pauseJob(job) {
        if (!job._isStarted) {
            await alert('Selected job has not been started or is already paused.', this.appInfo.appTitle);
            return;
        }

        this.appInfo.pleaseWaitShow();
        await this.utility.pauseJob(job.id);
        this.appInfo.pleaseWaitHide();
        await alert('Job paused.', this.appInfo.appTitle);
    }

    async createRecurringJob(job) {
        let recurringJob = this.uow.recurringJobs.createEntity({
            created: new Date(),
            createdBy: this.auth.userValue.userName,
            startDate: this.scheduleDate,
            endDate: moment(this.scheduleDate).add(1, 'years').toDate(),
            frequency: 7,
            frequencyUnit: 'Days'
        });

        const dialogRef = this.dialogService.open(RecurringJobDialogComponent);
        dialogRef.instance.recurringJob = recurringJob;
        const result = await dialogRef.instance.show();
        if (result.success) {
            this.appInfo.pleaseWaitShow();
            await this.uow.commit();
            const numCreated = await this.utility.createJobsForRecurringJob(recurringJob.id, job.id, this.auth.userValue.userName);
            await this.getData();
            this.appInfo.pleaseWaitHide();
            await alert(`${numCreated} jobs created.`, this.appInfo.company);
        } else this.uow.rollback();
        this.dialogService.close(dialogRef);
    }
}
